export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-5ee5d165f484ae0bbaad89f2c655dc03.eot";